import { useEffect, useState, useRef } from 'react';

export default function InfoButton({ text, position = 'left', size = 'normal' }: { text: string; position?: 'left' | 'below'; size?: 'normal' | 'small' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Close on any outside click — no blocking overlay so scrolling still works
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div ref={ref} className="relative inline-flex items-center">
      <button
        onClick={() => setOpen(o => !o)}
        className={`${size === 'small' ? 'w-4 h-4' : 'w-8 h-8'} rounded-full flex items-center justify-center transition-colors ${
          open
            ? 'bg-accent-primary text-white shadow-md'
            : size === 'small'
              ? 'text-gray-400 dark:text-primary-400 hover:text-gray-600 dark:hover:text-primary-200'
              : 'bg-gray-200 dark:bg-primary-600 text-gray-500 dark:text-primary-300 hover:bg-gray-300 dark:hover:bg-primary-500 hover:text-gray-700 dark:hover:text-primary-100'
        }`}
        aria-label="Info"
      >
        <svg className={size === 'small' ? 'w-3.5 h-3.5' : 'w-4.5 h-4.5'} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4M12 8h.01" strokeLinecap="round" />
        </svg>
      </button>
      {open && position === 'left' && (
        <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2.5 z-20 w-96 p-3.5 bg-white dark:bg-primary-700 rounded-lg shadow-lg border border-gray-200 dark:border-primary-500 text-[13px] text-gray-700 dark:text-primary-100 leading-relaxed">
          {text}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full w-0 h-0 border-[6px] border-transparent border-l-white dark:border-l-primary-700" />
        </div>
      )}
      {open && position === 'below' && (
        <div className="absolute top-full right-0 mt-2.5 z-20 w-72 p-3.5 bg-white dark:bg-primary-700 rounded-lg shadow-lg border border-gray-200 dark:border-primary-500 text-[13px] text-gray-700 dark:text-primary-100 leading-relaxed">
          {text}
          <div className="absolute top-0 right-3 -translate-y-full w-0 h-0 border-[6px] border-transparent border-b-white dark:border-b-primary-700" />
        </div>
      )}
    </div>
  );
}
